module.exports = __webpack_public_path__ + "static/media/slide-curs-resurse-digitale.3472cd23.jpg";